// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { addStationDetails } from '../../redux/reducers/stations';

import Loader from '../../components/Loader/Loader';
import MessageBlock from '../../components/MessageBlock/MessageBlock';

import FormWrapper from '../../components/shared/FormWrapper';

import StationAddForm from '../../components/Stations/Add';

class StationsAdd extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formValues) {
        const { dispatch, history } = this.props;

        const stationData = {
            stationName: formValues.name,
            stationCode: formValues.code,
            stationLat: formValues.lat,
            stationLong: formValues.long,
        };

        dispatch(addStationDetails(stationData)).then(updatedStation => {
            history.push('/stations');
        });
    }

    render() {
        const { isFetching, errorFetching } = this.props;

        if (errorFetching) {
            return (
                <FormWrapper>
                    <MessageBlock message="An unexpected error occurred whilst loading this station." />
                </FormWrapper>
            );
        }

        if (isFetching) {
            return (
                <FormWrapper>
                    <Loader message="Loading station, please wait..." />
                </FormWrapper>
            );
        }

        return (
            <FormWrapper>
                <StationAddForm onSubmit={this.onSubmit} />
            </FormWrapper>
        );
    }
}

const mapStateToProps = state => {
    const add = state.stations.add;

    return {
        errorFetching: add.error,
        isFetching: add.fetching,
        station: add.station,
    };
};

export default withRouter(connect(mapStateToProps)(StationsAdd));



// WEBPACK FOOTER //
// ./src/containers/StationsAdd/StationsAdd.js